<template>
  <div class="goods1">
    <div class="mb20">
      可以添加明星老师，每个老师会展示图片，姓名和标签。可以拖动排序
    </div>
    <draggable
      v-model="currentInfo.wxSchoolPageItemList"
      @update="datadragEndContent"
      :options="{ animation: 500 }"
    >
      <div
        v-for="(item, index) in currentInfo.wxSchoolPageItemList"
        :key="index"
      >
        <div
          class="flex jc-sb cp wx-item-style"
          @click="addGoodSingleBtn(index)"
        >
          <div class="ellipsis">{{ item.schoolPageInfo.title }}</div>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            @click.stop="deleteBtn(index)"
          ></el-button>
        </div>
      </div>
    </draggable>
    <div class="jc-center mt20">
      <el-button type="primary" @click="addGoodsBtn()">添加</el-button>
    </div>
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
export default {
  mixins: [codeMixin],

  methods: {
    deleteBtn(index) {
      this.$confirm("确认删除？")
        .then((_) => {
          this.currentInfo.wxSchoolPageItemList.splice(index, 1);
        })
        .catch((_) => {});
    },
    //多选
    addGoodsBtn() {
      this.$store.commit("design/SET_ADDDIALOGVISIBLE", {
        addDialogVisible: true,
      });
    },
    //选单个
    addGoodSingleBtn(index) {
      this.$store.commit("design/SET_ADDDIALOGVISIBLE", {
        addDialogVisible: true,
        single: true,
        singleIndex: index,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goods1 {
  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    border: 1px dashed rgb(196, 192, 192);
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    .el-icon-plus {
      font-size: 36px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
  .jc-sb {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 10px;
    border-radius: 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/banner/banner2/setting.vue